import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { rulesApi } from '../services/api';
import { getCategoryIconUrl } from '../utils/images';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Loading from '../components/Loading';
import SEO from '../components/SEO';
import './Categories.css';

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCategories = useCallback(async () => {
    try {
      setLoading(true);
      const response = await rulesApi.getCategories();
      let list = [];
      if (Array.isArray(response.data)) {
        list = response.data;
      } else if (response.data && response.data.data) {
        list = response.data.data;
      }
      setCategories(list);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load categories');
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  return (
    <>
      <SEO
        title="All Categories"
        description="Browse Guy Rules by category: wife, tools, family, dating, sports, and more."
        canonicalPath="/categories"
      />
      <Header />
      <div className="container">
        <div className="categories-page">
          <h1>Categories</h1>

          {loading ? (
            <Loading />
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="categories-grid">
              {categories.length === 0 ? (
                <p className="categories-empty">No categories found</p>
              ) : (
                categories.map((category) => (
                  <Link
                    key={category.cat_id || category.id}
                    to={`/rules/category/${category.cat_id || category.id}`}
                    className="category-card-link"
                  >
                    <article className="category-card">
                      <div className="category-card-header">
                        {category.icon && (
                          <img
                            src={getCategoryIconUrl(category.icon)}
                            alt=""
                            className="category-card-icon"
                          />
                        )}
                        <h2 className="category-card-name">{category.name}</h2>
                      </div>
                      {category.description && (
                        <p className="category-card-description">{category.description}</p>
                      )}
                    </article>
                  </Link>
                ))
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Categories;
